import Code from "../../../components/code";
import DocsAuthor from "../../components/docsAuthor";

export const nekoCliWindowsInstallation = {
  title: "Neko-CLI for Windows 💻",
  sections: [
    {
      id: "quick-start",
      name: "Quick Start ⚡",
    },
  ],
  content: (
    <>
      <DocsAuthor nickname="StrayVibes" publishedAt="June 11, 2025 at 09:30 AM" />
      <section id="quick-start">
        <h2>Quick Start ⚡</h2>
        <p>
          Get <strong>Neko-CLI</strong> up and running on your{" "}
          <strong>Windows</strong> machine quickly!
        </p>

        <h3>Prerequisites:</h3>
        <p>
          To use Neko-CLI, you'll need <strong>Node.js</strong> installed on your
          system. Node.js comes bundled with <strong>npm</strong> (Node Package
          Manager), which we'll use to install Neko-CLI.
        </p>
        <p>
          If you don't have Node.js installed, download the{" "}
          <strong>Windows Installer</strong> directly from the official Node.js
          website.
          <br />
          <strong>Note:</strong> The dedicated Neko-CLI Windows Installer is
          currently under construction. For now, please use the classic npm
          installation method described below.
        </p>
        <p>
          Follow the instructions in the Node.js installer. We recommend choosing
          the <strong>LTS (Long Term Support)</strong> version for stability.
        </p>
        <p>
          After installing Node.js, open your <strong>Command Prompt</strong> or{" "}
          <strong>PowerShell</strong> and verify the installation by checking the
          Node.js and npm versions:
          <br />
          <Code>node -v</Code>
          <br />
          <Code>npm -v</Code>
        </p>
        <p>
          You should see version numbers for both, confirming they are installed
          correctly.
        </p>

        <h3>Installation:</h3>
        <p>
          Once Node.js and npm are set up, you can install{" "}
          <strong>Neko-CLI</strong> globally using npm. This allows you to use the{" "}
          <Code>meow</Code> command from any directory in your terminal.
        </p>
        <Code>npm install -g neko-cli</Code>
        <p>
          The <Code>-g</Code> flag ensures a <strong>global install</strong>,
          making the <Code>meow</Code> command accessible system-wide. 🚀
        </p>

        <h3>Verify Install:</h3>
        <p>
          To confirm Neko-CLI is installed and working, check its version:
        </p>
        <Code>meow version</Code>
        <p>
          If a version number is displayed, you're all set! 🎉 You can now type{" "}
          <Code>meow help</Code> to explore all the available commands. 😉
        </p>
      </section>
    </>
  ),
};
